// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3xH6l","footer":"ModalInfo_footer__eWLWd"};